import SignIn from '@/feature/sign_in'

export default SignIn
